import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { useHistory, useParams } from 'react-router'
import { Container, Grid, TextField, FormGroup, FormControlLabel, Checkbox, Button } from '@material-ui/core'
import { Refresh } from '@material-ui/icons'
import { settingAPI } from './../services/SettingService'
import { Formik, Form } from "formik";

const Setting_Edit_Type = () => {
    let history = useHistory()
    const { _id } = useParams()
    const token = localStorage.getItem("Token")
    const [data, setData] = useState(null)

    useEffect(() => {
        settingAPI.getTypeByID(token, _id)
            .then((res) => {
                if (res.status == 200) {
                    setData(res.message)
                    document.title = `Com7 Merchandise - ${res.message.type_name}`
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 5000
                    }).then(() => {
                        history.push("/settings/type")
                    })
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: 'transparent',
                    background: 'rgba(0,0,0,.75)',
                    customClass: {
                        icon: 'switch'
                    },
                    width: '28rem',
                    timer: 5000
                }).then(() => {
                    history.push("/settings/type")
                })
            })
    }, [_id])


    return (
        data && <Formik
            initialValues={{ due_time: 1, ...data }}
            enableReinitialize
            onSubmit={async (values, { resetForm, setSubmitting }) => {
                try {
                    Swal.fire({
                        title: 'คุณแน่ใจ ?',
                        text: `ต้องการแก้ไข ${values.type_name} ?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#56A834',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'แน่ใจ',
                        cancelButtonText: 'ยังก่อน'
                    })
                        .then(async (result) => {
                            try {
                                if (result.isConfirmed) {
                                    setSubmitting(true)
                                    let form = new FormData();
                                    form.append("_id", values._id)
                                    form.append("is_link", values.is_link)
                                    form.append("email", values.email)
                                    form.append("buyer", values.buyer)
                                    form.append("status", values.status);
                                    form.append("due_time", values.due_time * 3600);
                                    if (data.type_name != values.type_name) {
                                        form.append("type_name", values.type_name)
                                        const { isConfirmed } = await Swal.fire({
                                            title: 'คุณแน่ใจ ?',
                                            text: `ต้องการเปลี่ยน Type ใน Work จาก ${data.type_name} เป็น ${values.type_name} ด้วยหรือไม่?`,
                                            icon: 'warning',
                                            showCancelButton: true,
                                            confirmButtonColor: '#56A834',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'แน่ใจ',
                                            cancelButtonText: 'ยังก่อน'
                                        })
                                        if (isConfirmed) {
                                            form.append("change_work", true)
                                        }
                                        else {
                                            form.append("change_work", false)
                                        }
                                    }
                                    settingAPI.EditType(token, form)
                                        .then((res) => {
                                            if (res.status == 200) {
                                                Swal.fire({
                                                    icon: 'success',
                                                    confirmButtonColor: "#6ab23a",
                                                    html: `<span class="colorWhite">${res.message}</span>`,
                                                    backdrop: 'transparent',
                                                    background: 'rgba(0,0,0,.75)',
                                                    customClass: {
                                                        icon: 'switchZ'
                                                    },
                                                    width: '28rem',
                                                    timer: 3000
                                                }).then((res) => {
                                                    history.push("/settings/type")
                                                })
                                            }
                                            else {
                                                Swal.fire({
                                                    icon: 'error',
                                                    confirmButtonColor: "#f27474",
                                                    html: `<span class="colorWhite">${res.message}</span>`,
                                                    backdrop: 'transparent',
                                                    background: 'rgba(0,0,0,.75)',
                                                    customClass: {
                                                        icon: 'switch'
                                                    },
                                                    width: '28rem',
                                                    timer: 3000
                                                })
                                            }
                                        })
                                        .catch((error) => {
                                            Swal.fire({
                                                icon: 'error',
                                                confirmButtonColor: "#f27474",
                                                html: `<span class="colorWhite">${error.message}</span>`,
                                                backdrop: 'transparent',
                                                background: 'rgba(0,0,0,.75)',
                                                customClass: {
                                                    icon: 'switch'
                                                },
                                                width: '28rem',
                                                timer: 3000
                                            })
                                        })
                                }
                            }
                            catch (error) {
                                setSubmitting(false)
                                Swal.fire({
                                    icon: 'error',
                                    confirmButtonColor: "#f27474",
                                    html: `<span class="colorWhite">${error.message}</span>`,
                                    backdrop: 'transparent',
                                    background: 'rgba(0,0,0,.75)',
                                    customClass: {
                                        icon: 'switch'
                                    },
                                    width: '28rem',
                                    timer: 3000
                                })
                            }
                        })
                }
                catch (error) {
                    setSubmitting(false)
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 3000
                    })
                }
            }}
        >
            {({
                values,
                handleChange,
                setFieldValue,
                isSubmitting,
                touched,
                errors,
                resetForm
            }) => (
                <Form>
                    <Container style={{ padding: '20px', backgroundColor: '#ffffffbd', borderRadius: '10px' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <h3><strong>แก้ไข Type <Refresh fontSize="small" style={{ cursor: 'pointer' }} onClick={() => resetForm({ ...data })} /></strong></h3>
                            </Grid>
                        </Grid>
                        <Container style={{ paddingTop: '1rem' }}>
                            <div className="row">
                                <div className="pt-5 col-lg-12">
                                    <div className="row">
                                        <div className="mt-4 col-lg-12">
                                            <TextField
                                                name="type_name"
                                                style={{ width: '100%' }}
                                                value={values.type_name}
                                                label="ชื่อ Type…"
                                                onChange={handleChange}
                                            />
                                            {errors.type_name && touched.type_name ? (
                                                <div style={{ color: "#FF3333" }}>{errors.type_name}</div>
                                            ) : null}
                                        </div>
                                        <div className="mt-4 col-lg-12">
                                            <TextField
                                                type="number"
                                                style={{ width: '14%' }}
                                                value={values.due_time}
                                                name="due_time"
                                                onChange={handleChange}
                                                label="ระยะเวลาทำงาน (ชม.)..."
                                            />
                                        </div>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <div className="mt-4 col-12">
                                                    <label>
                                                        <strong>ส่งอีเมลล์</strong>
                                                    </label>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={values.email} onClick={() => setFieldValue('email', true)} />} label="Yes" />
                                                        <FormControlLabel control={<Checkbox checked={!values.email} onClick={() => setFieldValue('email', false)} />} label="No" />
                                                    </FormGroup>
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="mt-4 col-12">
                                                    <label>
                                                        <strong>Buyer สามารถเห็นได้</strong>
                                                    </label>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={values.buyer} onClick={() => setFieldValue('buyer', true)} />} label="Yes" />
                                                        <FormControlLabel control={<Checkbox checked={!values.buyer} onClick={() => setFieldValue('buyer', false)} />} label="No" />
                                                    </FormGroup>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <div className="mt-4 col-12">
                                                    <label>
                                                        <strong>แนบลิงค์ Google Drive</strong>
                                                    </label>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={values.is_link} onClick={() => setFieldValue('is_link', true)} />} label="Yes" />
                                                        <FormControlLabel control={<Checkbox checked={!values.is_link} onClick={() => setFieldValue('is_link', false)} />} label="No" />
                                                    </FormGroup>
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="mt-4 col-12">
                                                    <label>
                                                        <strong>สถานะการใช้งาน</strong>
                                                    </label>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={values.status} onClick={() => setFieldValue('status', true)} />} label="Active" />
                                                        <FormControlLabel control={<Checkbox checked={!values.status} onClick={() => setFieldValue('status', false)} />} label="Disable" />
                                                    </FormGroup>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        <div className="mt-4 col-12">
                                            <Button variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{
                                                    border: "2px solid transparent",
                                                    backgroundColor: "#6ab23a",
                                                    borderRadius: "5px",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    textDecoration: "none",
                                                    textTransform: "capitalize",
                                                }}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Container >
                </Form>)
            }
        </Formik >
    )
}

export default Setting_Edit_Type